<template>
  <div class="">
    <div class="sum_wrap">
      <div class="sum_contents">
        <h4 class="sum_title rb">購入代金合計</h4>
        <p class="sum_price rm"><span class="yen ab">￥</span>{{ purchaseTotalPrice.toLocaleString() }}</p>
      </div>
      <div class="sum_contents">
        <h4 class="sum_title rb">代金引換手数料</h4>
        <p class="sum_price rm"><span class="yen ab">￥</span>{{ purchaseCashOnDeliveryFee.toLocaleString() }}</p>
      </div>
      <div class="sum_contents">
        <h4 class="sum_title rb">送料</h4>
        <p class="sum_price rm"><span class="yen ab">￥</span>{{ purchaseShipmentFee.toLocaleString() }}</p>
      </div>

      <div class="sum_contents sum_coupon">
        <h4 class="sum_title rb">クーポン割引</h4>
        <p class="sum_price rm"><span class="yen ab">￥</span>{{ purchaseCouponDiscount.toLocaleString() }}</p>
      </div>
      <div class="sum_contents sum_coupon" v-if="purchaseBirthMonthDiscountPrice != 0">
        <h4 class="sum_title rb">誕生月割引</h4>
        <p class="sum_price rm"><span class="yen ab">￥</span>{{ purchaseBirthMonthDiscountPrice.toLocaleString() }}</p>
      </div>

      <div class="sum_contents sum_coupon">
        <h4 class="sum_title rb">ウォレット残高使用額</h4>
        <p class="sum_price rm"><span class="yen ab">￥</span>{{ purchaseWalletUseWallet == null || purchaseWalletUseWallet == 0 ? 0 : '-' + purchaseWalletUseWallet.toLocaleString() }}</p>
      </div>
      <div class="sum_contents sum_coupon">
        <h4 class="sum_title rb">お買い物ポイント使用額</h4>
        <p class="sum_price rm"><span class="yen ab">￥</span>{{ purchaseWalletUsePurchasePoint == null || purchaseWalletUsePurchasePoint == 0 ? 0 : '-' + purchaseWalletUsePurchasePoint.toLocaleString() }}</p>
      </div>
    </div>
    <div class="total_wrap pl16 pr17">
      <h3 class="total_price rm"><span class="yen ab">￥</span>{{ calcFinalPrice() }}</h3>
      <p class="total_point ab">ポイント：<span class="point_score rm">{{ purchaseTotalPoint.toLocaleString() }}</span><span class="point">pt</span></p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  methods: {
    calcFinalPrice () {
      let finalPrice = 0;
      finalPrice = (this.purchaseTotalPrice - this.purchaseWalletWalletAmount) + this.purchaseCashOnDeliveryFee + this.purchaseShipmentFee + this.purchaseCouponDiscount + this.purchaseBirthMonthDiscountPrice;
      return finalPrice.toLocaleString();
    },
  },
  computed: mapGetters([
    'purchaseTotalPrice',
    'purchaseTotalPoint',
    'purchaseWalletWalletAmount',
    'purchaseBirthMonthDiscountPrice',
    'purchaseCashOnDeliveryFee',
    'purchaseCouponDiscount',
    'purchaseShipmentFee',
    'purchaseUseBirthMonthDiscount',
    'purchaseWalletUseWallet',
    'purchaseWalletUsePurchasePoint'
  ]),
}
</script>

<style lang="css" scoped>
.sum_wrap {
  margin-top: 25px;
  padding: 0 15px;
}
.sum_contents {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.sum_contents:last-child {
  border-bottom: 1px solid #C9C9C9;
  padding-bottom: 13px;
}
.sum_title {
  font-size: 14px;
}
.yen {
  font-size: 12px;
}
.sum_price {
  font-size: 16px;
}
.sum_coupon {
  color: #ff0000;
}


.total_wrap {
  color: #009FA9;
  margin-top: 16px;
  text-align: right;
}

.total_wrap .total_price {
  font-size: 26px;
}

.total_wrap .yen {
  font-size: 20px;
}

.total_wrap .total_point {
  font-size: 12px;
  margin-top: 3px;
}
.total_wrap .point_score {
  font-size: 16px;
}
.total_wrap .point {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/AmountList.vue